import React, {useEffect} from "react";
import {useState} from "react";
import {Flex, HSeparator} from "./customStyled";
import {Input, Label} from "reactstrap";

/**
 *
 * @User : 백욱진
 * @Date : 2023.05.10
 * @file : Components/Common/CpmCommCodeCheckbox
 *.js
 * @Desc : 공통코드 체크박스 컴포넌트
 * @param {Object} cmCodes - 공통코드 데이터 [{label: string, value: string, checked: boolean, isDisabled?: boolean}]
 * @param {string} id - id값 (부모 컴포넌트의 파라미터 key 값으로도 사용)
 * @param {object} params - 부모 컴포넌트로부터 받아온 파라미터 객체
 * @param {React.SetStateAction} setParams - 부모 컴포넌트로부터 받아온 파라미터 세터
 * @param {boolean} isAll - 전체 선택 노출 Yn
 * @param {boolean} isDBlock - display : block Yn (default: false (flex))
 */

const CpmCommCodeCheckbox = ({id, cmCodes, params, setParams, isAll, isDBlock}) => {
    const paramNm = id || 'checkedValues' // param 이름
    const data = cmCodes || [
        {label: "신청", value: 1},
        {label: "가확정", value: 2},
        {label: "발송요청", value: 3},
        {label: "제외", value: 4},
        {label: "확정", value: 5},
        {label: "임시저장", value: 6},
    ];

    const [checkedItems, setCheckedItems] = useState(
        data.reduce((prev, cur) => ({
            ...prev,
            [cur.value]: cur.checked || params[paramNm]?.includes(cur.value)
        }), {}) // 부모 컴포넌트의 체크 데이터가 있다면 그 값 초기기 세팅
    ); // 체크된 아이템들을 객체 형식으로 저장
    const [checkAll, setCheckAll] = useState(false); // 전체 선택 여부

    // 전체 선택 
    const handleCheckAllChange = (e) => {
        setCheckAll(e.target.checked);
        setCheckedItems(
            data.reduce(
                (prev, cur) => ({
                    ...prev,
                    [cur.value]: e.target.checked
                }), {})
        ); // 전체 선택 상태에 따라 전체 체크박스 값 변경
        if (e.target.checked) {
            setParams({[paramNm]: data.map((item) => item.value)})
        } else {
            setParams({[paramNm]: []})
        }
    };

    // 체크박스 클릭시 데이터 세팅 함수
    const handleCheckChange = (e) => {
        setCheckedItems({...checkedItems, [e.target.value]: e.target.checked});
        let v = null ;
        try{
            v = JSON.parse(e.target.value)
        }catch (err) {
            v = e.target.value   ;
        }
        try{
            if (e.target.checked) {
                        setParams({[paramNm]: [...params[paramNm], v]});
                    } else { // 체크 false 시 param에서 데이터를 찾아 삭제
                        setParams({[paramNm]: params[paramNm]?.filter((value) => JSON.stringify(v) !== JSON.stringify(value)) });
                    }
        }catch (e) {
            console.log(e)
            
        }
    };

    useEffect(() => {
        // 모든 체크박스가 활성화되면 전체선택 체크박스 true로 변경
        setCheckAll(Object.values(checkedItems).every((item) => item));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkedItems, params[paramNm]]);

    useEffect(() => {
        // 부모 컴포넌트의 체크박스 데이터가 있다면 확인 후 다시 부모 컴포넌트 param에 세팅 
        const curr = data.reduce((prev, curr) => {
            if (curr.checked && !params[paramNm].some((el)=> JSON.stringify(el) === curr.value)) {
                return [...prev, JSON.parse(curr.value)]
            }
            return prev
        }, [])
        setParams({
            [paramNm]: [
                ...params[paramNm] || [],
                ...curr]
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={`${isDBlock ? null : 'd-flex'} flex-wrap`}>
            {isAll && (
                <Flex>
                    <div className="form-check">
                        <Input
                            id="formCheck_all"
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            name='체크박스'
                            onChange={handleCheckAllChange}
                        />
                        <Label
                            className="form-check-label text-nowrap"
                            htmlFor="formCheck_all"
                        >
                            전체
                        </Label>
                    </div>
                    <HSeparator/>
                </Flex>
            )}
            {data.map((el, idx ) => (
                <Flex key={`Form_Check_${el.value}_${idx}`}>
                    <div className="form-check">
                        <Input
                            id={`formCheck_${el.value}`}
                            className="form-check-input text-nowrap"
                            type="checkbox"
                            value={el.value}
                            name='체크박스'
                            checked={el?.checked || checkedItems[el.value] || false}
                            onChange={handleCheckChange}
                            disabled={el.isDisabled}
                            // checked = {checked ? 'ture' : undefined}
                        />
                        <Label
                            className="form-check-label text-nowrap"
                            htmlFor={`formCheck_${el.value}`}
                        >
                            {el.label}
                        </Label>
                    </div>
                    <HSeparator/>
                </Flex>
            ))}
        </div>
    );
};

export default CpmCommCodeCheckbox;
